import { createAction } from 'redux-actions';
import { getWorkpapersForElementRequest } from 'api/workpaper-api';
import { getFormulasForElementRequest } from 'api/formula-api';
import { getElementTickmarksRequest } from 'api/tickmark-api';
import { getComfortLetterForElementRequest } from 'api/comfort-letter-api';

const elementFormulaListLoading = createAction('ELEMENT_FORMULA_LIST_LOADING');
const elementFormulaListLoaded = createAction('ELEMENT_FORMULA_LIST_LOADED');
const elementFormulaListError = createAction('ELEMENT_FORMULA_LIST_ERROR');

const elementTickmarkListLoading = createAction(
  'ELEMENT_TICKMARK_LIST_LOADING',
);
const elementTickmarkListLoaded = createAction('ELEMENT_TICKMARK_LIST_LOADED');
const elementTickmarkListError = createAction('ELEMENT_TICKMARK_LIST_ERROR');

export const elementComfortLetterListLoading = createAction(
  'ELEMENT_COMFORT_LETTER_LIST_LOADING_ACTION',
);
export const elementComfortLetterListLoaded = createAction(
  'ELEMENT_COMFORT_LETTER_LIST_LOADED_ACTION',
);

export const elementComfortLetterListError = createAction(
  'ELEMENT_COMFORT_LETTER_LIST_ERROR',
);

export const elementWorkpaperListLoading = createAction(
  'ELEMENT_WORKPAPER_LIST_LOADING',
);
const elementWorkpaperListLoaded = createAction(
  'ELEMENT_WORKPAPER_LIST_LOADED',
);
const elementWorkpaperListError = createAction('ELEMENT_WORKPAPER_LIST_ERROR');
export const getElementWorkpapers =
  ({ elementId }) =>
  async (dispatch, getState) => {
    dispatch(elementWorkpaperListLoading());
    try {
      const { revision } = getState().data;
      const response = await getWorkpapersForElementRequest({
        elementId,
        revisionId: revision.id,
      });
      dispatch(
        elementWorkpaperListLoaded({
          response,
        }),
      );
    } catch (error) {
      dispatch(elementWorkpaperListError(error));
    }
  };

export const getElementFormulas =
  ({ elementId }) =>
  async (dispatch, getStore) => {
    const storeData = getStore().data;
    const {
      revision,
      elementPanel: { elementDetails } = {},
      statementContent: { elementCache } = {},
    } = storeData;

    dispatch(elementFormulaListLoading());
    try {
      const response = await getFormulasForElementRequest({
        elementId,
        revisionId: revision.id,
      });
      dispatch(
        elementFormulaListLoaded({
          response,
          elementCache,
          sectionId: elementDetails.sectionId,
        }),
      );
    } catch (error) {
      dispatch(elementFormulaListError(error));
    }
  };

export const getElementTickmarksWithoutLoading =
  ({ elementId }) =>
  async (dispatch, getState) => {
    try {
      const { revision } = getState().data;
      const response = await getElementTickmarksRequest({
        elementId,
        revisionId: revision.id,
      });
      await dispatch(elementTickmarkListLoaded({ response }));
    } catch (error) {
      dispatch(elementTickmarkListError(error));
    }
  };

export const getElementTickmarks =
  ({ elementId }) =>
  async (dispatch) => {
    await dispatch(elementTickmarkListLoading());
    await dispatch(getElementTickmarksWithoutLoading({ elementId }));
  };

export const getElementComfortLetters =
  ({ elementId }) =>
  async (dispatch) => {
    await dispatch(elementComfortLetterListLoading());
    await dispatch(getElementComfortLettersWithoutLoading({ elementId }));
  };

export const getElementComfortLettersWithoutLoading =
  ({ elementId }) =>
  async (dispatch, getState) => {
    try {
      const { revision } = getState().data;
      const response = await getComfortLetterForElementRequest({
        elementId,
        revisionId: revision.id,
      });
      await dispatch(elementComfortLetterListLoaded({ response }));
    } catch (error) {
      dispatch(elementComfortLetterListError(error));
    }
  };
